import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './user-session-model.js';

const defaultHandler = (state = INITIAL_STATE) => state;

const loggedIn = (state, { userToken, userName, expiration }) => ({
  ...state,
  isLoading: false,
  userToken,
  userName,
  expiration,
});

export const { Types, Creators } = createActions({
  // Action Types
  userSessionLoggedIn: ['userToken', 'userName', 'expiration'],

  // Async Actions
  userSessionLoginAsync: ['values'],
});

export default createReducer(INITIAL_STATE, {
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.USER_SESSION_LOGGED_IN]: loggedIn,
});
